<template>
    <div class="profile-main profile-area">
        <div
            v-if="!user || !avatarLengthCheck"
            class="profile-image"
            :style="{
                'background-image':
                    'url(' +
                    require('@/assets/images/dummy/dummy-user.png') +
                    ')',
            }"
        ></div>
        <div
            v-if="user && user.avatar && user.avatar.fileName"
            v-authenticated-image="'users/' + user.avatar.fileName"
            class="profile-image"
        ></div>
        <div v-if="user" class="profile-detail" @click="open">
            <h4>{{ user.firstName }} {{ user.lastName }}</h4>
            <p>{{ user.roleName }}</p>
            <i class="icon-caret-down"></i>
        </div>
        <login-popover
            v-if="showPopover"
            v-on-click-outside="close"
        ></login-popover>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import loginPopover from '@/components/LoginPopover.vue'
import { directive as onClickOutside } from 'vue-on-click-outside'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        loginPopover,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > directives
    |--------------------------------------------------------------------------
    */
    directives: {
        onClickOutside: onClickOutside,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {},
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPopover: false,
            avatarLengthCheck: 0,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['user']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.user) {
            this.avatarLengthCheck = Object.keys(this.user.avatar).length
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        open() {
            this.showPopover = true
        },
        close() {
            this.showPopover = false
        },
    }, // End of Component > mounted
} // End of export default
</script>
